export const headingNodeType = 'heading' as const
export const paragraphNodeType = 'paragraph' as const
export const reactComponentNodeType = 'reactcomponent' as const
export const imageNodeType = 'image' as const
export const headingNodeName = 'heading' as const
export const linkNodeType = 'link' as const
export const boldNodeType = 'bold' as const
export const italicNodeType = 'italic' as const
export const blockquoteNodeType = 'blockquote' as const
